import { useState } from 'react'
import { Link } from 'raviger'
import classnames from 'classnames'

import { mapRoutes } from '../menusTable'
import config from '../clientConfig'
import { Icon, Button } from '../ui/bootstrap/bootstrap'
import { tr } from 'react-hook-form-auto'
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import Cookie from 'js-cookie'

import styles from './MainMenu.sass'
import { HeaderLogin } from './HeaderLogin'

const themeIcons = {
  dark: 'moon',
  light: 'sun'
}

const ShopNavItem = props => {
  const {
    active,
    drop,
    textId,
    path,
    icon,
    theme
  } = props

  const dark = theme == 'dark'
  const classes = classnames(
    styles.link,
    'nav-link',
    {
      [styles.dark]: dark,
      [styles.selected]: active
    }
  )
  const $component = drop ? DropdownItem : NavItem
  const text = tr(textId)

  return (
    <$component>
      <Link href={path}>
        <span className={classes}>
          <Icon
            className={styles.innerLink}
            icon={icon}
            iconClass={styles.icon}
            text={text}
            textClass={styles.text}
            noMargin
          />
        </span>
      </Link>
    </$component>
  )
}

function setDarkMode(fromType, toType) {
  if (!config.ssr)
    localStorage.setItem('darkMode', toType)
  Cookie.set(config.themeCookie, toType, { expires: 1000, path: '' })
  document.body.classList.add(toType)
  document.body.classList.remove(fromType)
  document.body.dataset.bsTheme = toType
}

export const MainMenu = ({ page, equivalences, forceTheme }) => {
  const userTheme = forceTheme || Cookie.get(config.themeCookie) || 'light'

  const [ organizeShow, setOrganizeShow ] = useState(false)
  const [ theme, setTheme ] = useState(userTheme)

  const handleButtonClick = (e) => {
    e.preventDefault()
    setOrganizeShow(!organizeShow)
  }

  const handleThemeButton = () => {
    const newDarkType = theme == 'light' ? 'dark' : 'light'
    setTheme(newDarkType)
    setDarkMode(theme, newDarkType)
  }

  function renderMenus({ theme, menuTable }) {
    return mapRoutes(({ textId, icon, path, submenu }) => {
      const effectivePage = equivalences
        ? (equivalences[page] || page)
        : page
      const active = path == effectivePage

      if (submenu) {
        const classes = classnames(styles.link, {
          [styles.dark]: theme == 'dark'
        })

        return (
          <Dropdown
            key="dropdown"
            nav
            isOpen={organizeShow}
            toggle={handleButtonClick}
          >
            <DropdownToggle key="toggle" tag="a" href="#" caret className={classes}>
              {tr(textId)}
            </DropdownToggle>
            <DropdownMenu key="menu" className={classes}>
              {renderMenus({ theme: theme, menuTable: submenu })}
            </DropdownMenu>
          </Dropdown>
        )
      } else {
        return (
          <ShopNavItem
            active={active}
            key={path}
            textId={textId}
            icon={icon}
            path={path}
            drop={menuTable}
            theme={theme}
          />
        )
      }
    }, menuTable)
  }

  const dark = theme == 'dark'
  const headerClass = classnames(
    styles.header,
    {
      [styles.dark]: dark
    }
  )
  const rightClasses = classnames(
    styles.right,
    styles.login
  )

  return (
    <Navbar
      color={theme}
      light={theme == 'light'}
      dark={theme == 'dark'}
    >
      <div className={headerClass}>
        <NavbarBrand href="/shop" className={styles.brand}>
          {config.applicationName}
          {
            !config.isProd &&
              <span className={styles.vial}>
                <Icon icon="vial-virus" />
              </span>
          }
        </NavbarBrand>
        <Nav className={styles.nav}>
          {renderMenus({ theme: theme })}
          <li key="theme" className={styles.theme}>
            <Button iconClass={themeIcons[theme]} onClick={handleThemeButton}></Button>
          </li>
          <li key="login" className={rightClasses}>
            <HeaderLogin />
          </li>
        </Nav>
      </div>
    </Navbar>
  )
}
